// Auto-generated manifest for responsive images
export const responsiveManifest: Record<string, any> = {
    "background-removal-quality": {
        "200": "/assets/images/articles/responsive/background-removal-quality-200.webp",
        "300": "/assets/images/articles/responsive/background-removal-quality-300.webp",
        "400": "/assets/images/articles/responsive/background-removal-quality-400.webp",
        "600": "/assets/images/articles/responsive/background-removal-quality-600.webp",
        "800": "/assets/images/articles/responsive/background-removal-quality-800.webp",
        "1200": "/assets/images/articles/responsive/background-removal-quality-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAABQAQCdASoQAAsABUB8JZwABAAAAP7rxh5LwAAA"
    },
    "barcode-scanner-technology": {
        "200": "/assets/images/articles/responsive/barcode-scanner-technology-200.webp",
        "300": "/assets/images/articles/responsive/barcode-scanner-technology-300.webp",
        "400": "/assets/images/articles/responsive/barcode-scanner-technology-400.webp",
        "600": "/assets/images/articles/responsive/barcode-scanner-technology-600.webp",
        "800": "/assets/images/articles/responsive/barcode-scanner-technology-800.webp",
        "1200": "/assets/images/articles/responsive/barcode-scanner-technology-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAABwAwCdASoQABUAPzmMu1S/qaYjMAgD8CcJZQAAhAgWb3OY/UAA/syvpMsHAaSPBQAAAA=="
    },
    "data-format-comparison": {
        "200": "/assets/images/articles/responsive/data-format-comparison-200.webp",
        "300": "/assets/images/articles/responsive/data-format-comparison-300.webp",
        "400": "/assets/images/articles/responsive/data-format-comparison-400.webp",
        "600": "/assets/images/articles/responsive/data-format-comparison-600.webp",
        "800": "/assets/images/articles/responsive/data-format-comparison-800.webp",
        "1200": "/assets/images/articles/responsive/data-format-comparison-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACQAQCdASoQAAsABUB8JYgCdADBFTAA/rlD+JnzzQr90N2g0oAAAA=="
    },
    "diff-algorithms-explained-image1": {
        "200": "/assets/images/articles/responsive/diff-algorithms-explained-image1-200.webp",
        "300": "/assets/images/articles/responsive/diff-algorithms-explained-image1-300.webp",
        "400": "/assets/images/articles/responsive/diff-algorithms-explained-image1-400.webp",
        "600": "/assets/images/articles/responsive/diff-algorithms-explained-image1-600.webp",
        "800": "/assets/images/articles/responsive/diff-algorithms-explained-image1-800.webp",
        "1200": "/assets/images/articles/responsive/diff-algorithms-explained-image1-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAAAwAQCdASoQAAwABwB8JZwAA3AA/u1DWHuWwoAA"
    },
    "diff-algorithms-explained-image2": {
        "200": "/assets/images/articles/responsive/diff-algorithms-explained-image2-200.webp",
        "300": "/assets/images/articles/responsive/diff-algorithms-explained-image2-300.webp",
        "400": "/assets/images/articles/responsive/diff-algorithms-explained-image2-400.webp",
        "600": "/assets/images/articles/responsive/diff-algorithms-explained-image2-600.webp",
        "800": "/assets/images/articles/responsive/diff-algorithms-explained-image2-800.webp",
        "1200": "/assets/images/articles/responsive/diff-algorithms-explained-image2-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAAAwAQCdASoQAAoACoB8JaQAA3AA/u8bvBe8AAAA"
    },
    "diff-algorithms-explained-image3": {
        "200": "/assets/images/articles/responsive/diff-algorithms-explained-image3-200.webp",
        "300": "/assets/images/articles/responsive/diff-algorithms-explained-image3-300.webp",
        "400": "/assets/images/articles/responsive/diff-algorithms-explained-image3-400.webp",
        "600": "/assets/images/articles/responsive/diff-algorithms-explained-image3-600.webp",
        "800": "/assets/images/articles/responsive/diff-algorithms-explained-image3-800.webp",
        "1200": "/assets/images/articles/responsive/diff-algorithms-explained-image3-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAAAwAQCdASoQAA0ABUB8JaQAA3AA/u/qYsqqn5J3VqggAA=="
    },
    "diff-algorithms-explained": {
        "200": "/assets/images/articles/responsive/diff-algorithms-explained-200.webp",
        "300": "/assets/images/articles/responsive/diff-algorithms-explained-300.webp",
        "400": "/assets/images/articles/responsive/diff-algorithms-explained-400.webp",
        "600": "/assets/images/articles/responsive/diff-algorithms-explained-600.webp",
        "800": "/assets/images/articles/responsive/diff-algorithms-explained-800.webp",
        "1200": "/assets/images/articles/responsive/diff-algorithms-explained-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRi4AAABXRUJQVlA4ICIAAACwAQCdASoQAAkABUB8JZQAAlvvEWegAPyZofqOMP63LwAA"
    },
    "image-compression-physics": {
        "200": "/assets/images/articles/responsive/image-compression-physics-200.webp",
        "300": "/assets/images/articles/responsive/image-compression-physics-300.webp",
        "400": "/assets/images/articles/responsive/image-compression-physics-400.webp",
        "600": "/assets/images/articles/responsive/image-compression-physics-600.webp",
        "800": "/assets/images/articles/responsive/image-compression-physics-800.webp",
        "1200": "/assets/images/articles/responsive/image-compression-physics-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRjQAAABXRUJQVlA4ICgAAACwAQCdASoQAAsABUB8JZwAAd++YPQAAP6OqbevB+nqtaZy/Z+hAAAA"
    },
    "ocr-technology-explained": {
        "200": "/assets/images/articles/responsive/ocr-technology-explained-200.webp",
        "300": "/assets/images/articles/responsive/ocr-technology-explained-300.webp",
        "400": "/assets/images/articles/responsive/ocr-technology-explained-400.webp",
        "600": "/assets/images/articles/responsive/ocr-technology-explained-600.webp",
        "800": "/assets/images/articles/responsive/ocr-technology-explained-800.webp",
        "1200": "/assets/images/articles/responsive/ocr-technology-explained-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACQAQCdASoQAAsABUB8JQBOgCHL+KAA/ovTFRwKHVt4jLfJNAAAAA=="
    },
    "pdf-file-structure": {
        "200": "/assets/images/articles/responsive/pdf-file-structure-200.webp",
        "300": "/assets/images/articles/responsive/pdf-file-structure-300.webp",
        "400": "/assets/images/articles/responsive/pdf-file-structure-400.webp",
        "600": "/assets/images/articles/responsive/pdf-file-structure-600.webp",
        "800": "/assets/images/articles/responsive/pdf-file-structure-800.webp",
        "1200": "/assets/images/articles/responsive/pdf-file-structure-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAABwAQCdASoQAAsABUB8JaQAAg+4AAD+04fYxeGlJgKwEBlIAAA="
    },
    "qr-code-anatomy": {
        "200": "/assets/images/articles/responsive/qr-code-anatomy-200.webp",
        "300": "/assets/images/articles/responsive/qr-code-anatomy-300.webp",
        "400": "/assets/images/articles/responsive/qr-code-anatomy-400.webp",
        "600": "/assets/images/articles/responsive/qr-code-anatomy-600.webp",
        "800": "/assets/images/articles/responsive/qr-code-anatomy-800.webp",
        "1200": "/assets/images/articles/responsive/qr-code-anatomy-1200.webp",
        "placeholder": "data:image/webp;base64,UklGRi4AAABXRUJQVlA4ICIAAABwAQCdASoQAAsABwB8JYgCdAFAAAD+z/0z8nV9pWq2gAAA"
    },
};
